function UserProfileBlock({ onLogout, setPage }) {
  const stored = localStorage.getItem("user") || sessionStorage.getItem("user");
  let parsed = {};
  try {
    parsed = stored ? JSON.parse(stored) : {};
  } catch {}

  return (
    <>
      <div
        className="sb-user"
        style={{ display: "flex", alignItems: "center", gap: 10 }}
      >
        <button
          className="sb-avatar"
          title="Edit profile"
          onClick={() => setPage && setPage("account-settings")}
          style={{ cursor: "pointer" }}
        >
          {parsed.name ? parsed.name.charAt(0).toUpperCase() : "U"}
        </button>
        <div style={{ flex: 1 }}>
          <div className="sb-uname">
            {[parsed.name, parsed.surname].filter(Boolean).join(" ") ||
              parsed.fullname ||
              parsed.username ||
              "Guest User"}
          </div>
          <div className="sb-urole" style={{ fontSize: 11 }}>
            {parsed.email || parsed.email_address || ""}
          </div>
        </div>
      </div>
      <button onClick={onLogout} className="sb-logout">
        <i className="bi bi-box-arrow-right" />
        Sign Out
      </button>
    </>
  );
}

function Sidebar({
  page,
  setPage,
  overdueCount,
  alertCount,
  pendingCount,
  permissions,
}) {
  const nav = [
    {
      id: "dashboard",
      icon: <i className="bi bi-speedometer2" />,
      label: "Dashboard",
      section: "OVERVIEW",
    },
    {
      id: "orders",
      icon: <i className="bi bi-box-seam" />,
      label: "Orders",
      badge: pendingCount > 0 ? pendingCount : null,
      section: "CORE",
    },
    {
      id: "collection",
      icon: <i className="bi bi-wallet2" />,
      label: "Collection",
      badge: overdueCount > 0 ? overdueCount : null,
      section: "CORE",
    },
    {
      id: "Inventory 1",
      icon: <i className="bi bi-clipboard" />,
      label: "Inventory",
      section: "CORE",
    },
    /*{
      id: "Inventory",
      icon: <i className="bi bi-clipboard" />,
      label: "Inventory",
      section: "OPERATIONS",
    },*/
    {
      id: "Branch",
      icon: <i className="bi bi-diagram-2" />,
      label: "Branches",
      section: "OPERATIONS",
    },
    {
      id: "warehouses",
      icon: <i className="bi bi-house-door" />,
      label: "Warehouses",
      section: "OPERATIONS",
    },
    {
      id: "deliveries",
      icon: <i className="bi bi-truck" />,
      label: "Transit",
      section: "OPERATIONS",
    },
    {
      id: "reporting",
      icon: <i className="bi bi-bar-chart-line-fill" />,
      label: "Reporting",
      section: "ANALYTICS",
    },
    {
      id: "Maintenance",
      icon: <i className="bi bi-gear" />,
      label: "Maintenance",
      section: "SYSTEM",
    },
  ];

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.reload();
  };

  // Null-safe: if permissions hasn't loaded yet, show all nav items
  const allowedNav = nav.filter((item) =>
    permissions ? permissions.canSeePage(item.id) : true,
  );

  let lastSection = null;
  return (
    <div className="sb">
      <div className="sb-brand">
        <svg
          width="210"
          height="62"
          viewBox="0 0 210 62"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon points="34,6 52,16 34,26 15,16" fill="#1a9e96" />
          <polygon points="15,16 34,25 34,48 16,38" fill="#147a74" />
          <polygon points="52,16 34,26 34,48 52,38" fill="#22c4bb" />
          <path
            d="M10,36 Q2,50 22,54 Q42,58 60,44 Q72,34 64,26"
            fill="none"
            stroke="#1a9e96"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <circle cx="60" cy="8" r="6" fill="#1a9e96" />
          <text
            x="73"
            y="33"
            fontFamily="Arial,sans-serif"
            fontSize="24"
            fontWeight="800"
            fill="#1a9e96"
            letterSpacing="-0.5"
          >
            BETA
          </text>
          <line
            x1="70"
            y1="46"
            x2="120"
            y2="46"
            stroke="#1a9e96"
            strokeWidth="0.9"
          />
          <line
            x1="152"
            y1="46"
            x2="210"
            y2="46"
            stroke="#1a9e96"
            strokeWidth="0.9"
          />
          <text
            x="138"
            y="49"
            fontFamily="Arial,sans-serif"
            fontSize="10"
            fontWeight="700"
            fill="#1a9e96"
            textAnchor="middle"
            letterSpacing="4"
          >
            CRM
          </text>
        </svg>
        <div></div>
      </div>

      <div className="sb-nav">
        {allowedNav.map((item) => {
          const showSection = item.section && item.section !== lastSection;
          if (item.section) lastSection = item.section;
          return (
            <div key={item.id}>
              {showSection && <div className="sb-section">{item.section}</div>}
              <div
                className={`nav ${page === item.id ? "on" : ""}`}
                onClick={() => setPage(item.id)}
              >
                <span className="nav-ico">{item.icon}</span>
                <span className="nav-lbl">{item.label}</span>
                {item.badge != null && <span className="nav-badge"></span>}
              </div>
            </div>
          );
        })}
      </div>
      <div className="sb-footer">
        <UserProfileBlock onLogout={handleLogout} setPage={setPage} />

        <a
          href="https://seritonex.com/"
          target="_blank"
          rel="noreferrer"
          style={{
            display: "block",
            marginTop: "10px",
            textAlign: "center",
            color: "#00b894",
            fontSize: "11px",
            fontWeight: "600",
            textDecoration: "none",
            letterSpacing: "0.3px",
          }}
        >
          Powered by Seritonex
        </a>
      </div>
    </div>
  );
}

export default Sidebar;
